import { withChangePasswordSubmit } from '@psyomics/ui-common';
import { BackLink, ChangePasswordForm } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { getConfig } from '../../../config';

const ChangePasswordWithSubmit = withChangePasswordSubmit(ChangePasswordForm);

const ChangePassword = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { patientApiUrl } = getConfig();

  const handleSuccess = () => {
    navigate('/account/change-password-success');
  };

  return (
    <div className="relative flex justify-center">
      <div className="max-w-[680px] w-full mx-auto h-full pt-0 p-6">
        <div className="mb-6">
          <BackLink onBack={() => navigate('/account')} text={t('common.buttons.backLink')} />
        </div>
        <ChangePasswordWithSubmit apiUrl={patientApiUrl} onSuccess={handleSuccess} />
      </div>
    </div>
  );
};

export { ChangePassword };
